import { stores } from 'src/stores';
import { Dealer, D4URxEvent, UserDetails } from 'src/utils/classes';
import { API_URL } from '../utils/api_url';

// const baseURL = 'https://api.fordshowtracker.com/';
const baseURL = API_URL;

const handleUnauthorized = () => {
  stores.login.doLogout();
  window.location.href = '/login';
};

const doFetch = async (url: RequestInfo, options: RequestInit, skipResults: boolean = false): Promise<D4URxFetchResult> => {
  // console.log('[d4ur]', 'doFetch', url);

  // add standard header stuff
  options.headers = {
    'Content-Type': 'application/json',
    'Authorization': stores.login.userToken,
    'latitude-app-version': `web:${stores.ui.appVersion}`,
    ...options.headers,
  };

  const response = await window.fetch(url, options);

  // Token is expired or invalid — clear auth and send to login
  if (response.status === 401) {
    handleUnauthorized();
  }

  let result: object;
  try {
    // .tojson() failing on most responses from d4ur api
    try {
      result = await response.json();
    } catch (e: unknown) {
      console.error(`[doFetch]`, e);
      result = response;
    }
  } catch (e: unknown) {
    console.error(`[doFetch]`, e);
    result = {};
  }

  // console.log(`response ${url}`, {
  //   status: response.status,
  //   statusText: response.statusText,
  //   data: result,
  //   headers: response.headers,
  // });
  return { response, result };
}

const doMultipart = async (url: RequestInfo, options: RequestInit, skipResults: boolean = false): Promise<D4URxFetchResult> => {
  // console.log('[d4ur]', 'doMultipart', url);

  // add standard header stuff
  options.headers = {
    'Authorization': stores.login.userToken,
    'latitude-app-version': `web:${stores.ui.appVersion}`,
    ...options.headers,
  };
  console.log('RequestInit!!!!!!', options);

  const response = await window.fetch(url, options);

  if (response.status === 401) {
    handleUnauthorized();
  }

  let result: object;
  try {
    result = await response.json();
  } catch (e: unknown) {
    console.error(`[doMultipart]`, e);
    result = {};
  }

  // console.log(`response ${url}`, {
  //   status: response.status,
  //   statusText: response.statusText,
  //   data: result,
  //   headers: response.headers,
  // });
  return { response, result };
}

class D4URxService implements IService {
  init = async () => {
    console.log(`[FordD4URAPI] init`);
  }

  doLogin = async (email: string, password: string): Promise<D4URxFetchResult | unknown | undefined> => {
    console.log(`[FordD4URAPI] doLogin`);

    try {
      stores.ui.setIsLoggingIn(true);

      const requestOptions: RequestInit = {
        method: 'POST',
        body: JSON.stringify({ email, password }),
      };

      const ret = await doFetch(`${baseURL}v1/auth/signinD4UR`, requestOptions);
      setTimeout(() => {
        stores.ui.setIsLoggingIn(false);
      }, 1000);
      return ret;
    } catch (e) {
      // handle error
      console.error('doLogin', e);
      stores.ui.setIsLoggingIn(false);
      console.error(`[FordD4URAPI] doLogin`, e);
      return e;
    }
  }

  doForgotPassword = async (contact_email: string): Promise<D4URxFetchResult | unknown | undefined> => {
    console.log(`[FordD4URAPI] doForgotPassword`);

    try {
      stores.ui.setIsResettingPassword(true);
      const requestOptions: RequestInit = {
        method: 'POST',
        body: JSON.stringify({
          contact_email,
        }),
      };

      const ret = await doFetch(`${baseURL}v1/auth/verify_email`, requestOptions);
      setTimeout(() => {
        stores.ui.setIsResettingPassword(false);
      }, 1000);
      return ret;
    } catch (e) {
      // handle error
      console.error('doForgotPassword', e);
      stores.ui.setIsResettingPassword(false);
      console.error(`[FordD4URAPI] doForgotPassword error`, e);
      return e;
    }
  }

  doResetPassword = async (password: string, token: string): Promise<D4URxFetchResult | unknown | undefined> => {
    console.log(`[FordD4URAPI] doResetPassword`);

    try {
      stores.ui.setIsResettingPassword(true);
      const requestOptions: RequestInit = {
        method: 'POST',
        body: JSON.stringify({
          password,
        }),
        headers: { token }
      };

      const ret = await doFetch(`${baseURL}v1/auth/change_password`, requestOptions);
      setTimeout(() => {
        stores.ui.setIsResettingPassword(false);
      }, 1000);
      return ret;
    } catch (e) {
      // handle error
      console.error('doForgotPassword', e);
      stores.ui.setIsResettingPassword(false);
      console.error(`[FordD4URAPI] doResetPassword error`, e);
      return e;
    }
  }

  doLogout = async (): Promise<D4URxFetchResult | unknown | undefined> => {
    console.log(`[FordD4URAPI] doLogout`);

    try {
      stores.ui.setIsLoggingOut(true);
      const requestOptions: RequestInit = {
        method: 'POST',
      };

      await doFetch(`${baseURL}logout`, requestOptions);

      stores.login.doLogout();
      stores.ui.setIsLoggingOut(false);
      return;
    } catch (e) {
      // handle error
      console.error('doLogout', e);
      console.error(`[FordD4URAPI] doLogout error`, e);
      return e;
    }
  }

  getEvents = async (seasonID: number): Promise<D4URxFetchResult | unknown | undefined> => {
    console.log(`[FordD4URAPI] getEvents`);

    try {
      const requestOptions: RequestInit = {
        method: 'GET',
      };

      // TODO: eventually let them pick seasons
      const ret = await doFetch(`${baseURL}v1/event/allD4UR?season_id=${seasonID}`, requestOptions);
      return ret;
    } catch (e) {
      // handle error
      console.error('getEvents', e);
      console.error(`[FordD4URAPI] getEvents`, e);
      return e;
    }
  }

  // Data tab: declined dealers who reapplied in a season
  getReapplications = async (seasonID: number): Promise<D4URxFetchResult | unknown | undefined> => {
    try {
      const requestOptions: RequestInit = { method: 'GET' };
      return await doFetch(`${baseURL}v1/event/data/reapplications?season_id=${seasonID}`, requestOptions);
    } catch (e) {
      console.error(`[FordD4URAPI] getReapplications`, e);
      return e;
    }
  }

  getRRDData = async (seasonID: number): Promise<D4URxFetchResult | unknown | undefined> => {
    console.log(`[FordD4URAPI] getRRDData`);

    try {
      const requestOptions: RequestInit = {
        method: 'GET',
      };

      const ret = await doFetch(`${baseURL}v1/event/kitDelivery?season_id=${seasonID}`, requestOptions);
      return ret;
    } catch (e) {
      // handle error
      console.error('getRRDData', e);
      console.error(`[FordD4URAPI] getRRDData`, e);
      return e;
    }
  }

  updateTracking = async (event_id: number, tracking_number: string): Promise<D4URxFetchResult | unknown | undefined> => {
    // for kit tracking, not checks
    console.log(`[FordD4URAPI] updateTracking`);

    try {
      const requestOptions: RequestInit = {
        method: 'POST',
        body: JSON.stringify({ event_id, tracking_number }),
      };

      const ret = await doFetch(`${baseURL}v1/event/update-tracking-number`, requestOptions);
      return ret;
    } catch (e) {
      // handle error
      console.error('updateTracking', e);
      console.error(`[FordD4URAPI] updateTracking`, e);
      return e;
    }
  }

  updateSecondaryTracking = async (event_id: number, secondary_tracking_number: string): Promise<D4URxFetchResult | unknown | undefined> => {
    try {
      const requestOptions: RequestInit = {
        method: 'POST',
        body: JSON.stringify({ event_id, secondary_tracking_number }),
      };
      const ret = await doFetch(`${baseURL}v1/event/update-secondary-tracking-number`, requestOptions);
      return ret;
    } catch (e) {
      console.error('updateSecondaryTracking', e);
      console.error(`[FordD4URAPI] updateSecondaryTracking`, e);
      return e;
    }
  }

  updateShipDate = async (event_id: number, ship_date: string): Promise<D4URxFetchResult | unknown | undefined> => {
    // for kit tracking, not checks
    console.log(`[FordD4URAPI] updateShipDate`);

    try {
      const requestOptions: RequestInit = {
        method: 'POST',
        body: JSON.stringify({ event_id, ship_date }),
      };

      const ret = await doFetch(`${baseURL}v1/event/update-ship-date`, requestOptions);
      return ret;
    } catch (e) {
      // handle error
      console.error('updateShipDate', e);
      console.error(`[FordD4URAPI] updateShipDate`, e);
      return e;
    }
  }

  updateSpanishKit = async (event_id: number, gets_spanish_kit: number): Promise<D4URxFetchResult | unknown | undefined> => {
  
    try {
      const requestOptions: RequestInit = {
        method: 'POST',
        body: JSON.stringify({ event_id, gets_spanish_kit }),
      };
  
      const ret = await doFetch(`${baseURL}v1/event/update-spanish-kit`, requestOptions);
      return ret;
    } catch (e) {
      // handle error
      console.error('updateSpanishKit', e);
      console.error(`[FordD4URAPI] updateSpanishKit`, e);
      return e;
    }
  }

  setBlueCruiseStatus = async (event_id: number, is_blue_cruise: boolean): Promise<D4URxFetchResult | unknown | undefined> => {
    console.log(`[FordD4URAPI] setBlueCruiseStatus`);

    try {
      const requestOptions: RequestInit = {
        method: 'POST',
        body: JSON.stringify({ event_id, is_blue_cruise }),
      };

      const ret = await doFetch(`${baseURL}v1/event/set-blue-cruise`, requestOptions);
      return ret;
    } catch (e) {
      // handle error
      console.error('setBlueCruiseStatus', e);
      console.error(`[FordD4URAPI] setBlueCruiseStatus`, e);
      return e;
    }
  }

  setOutreachStatus = async (event_id: number, outreach_done: boolean): Promise<D4URxFetchResult | unknown | undefined> => {
    console.log(`[FordD4URAPI] setOutreachStatus`);

    try {
      const requestOptions: RequestInit = {
        method: 'POST',
        body: JSON.stringify({ event_id, outreach_done }),
      };

      const ret = await doFetch(`${baseURL}v1/event/set-outreach-status`, requestOptions);
      return ret;
    } catch (e) {
      // handle error
      console.error('setOutreachStatus', e);
      console.error(`[FordD4URAPI] setOutreachStatus`, e);
      return e;
    }
  }

  // Dealer Feedback (D4URX-2752): per-event notes, addressed by id
  addDealerFeedback = async (event_id: number, note: string, contact: string, created_by_name: string): Promise<D4URxFetchResult | unknown | undefined> => {
    try {
      const requestOptions: RequestInit = {
        method: 'POST',
        body: JSON.stringify({ event_id, note, contact, created_by_name }),
      };
      return await doFetch(`${baseURL}v1/event/add-dealer-feedback`, requestOptions);
    } catch (e) {
      console.error(`[FordD4URAPI] addDealerFeedback`, e);
      return e;
    }
  }

  updateDealerFeedback = async (event_id: number, id: string, note: string, contact: string): Promise<D4URxFetchResult | unknown | undefined> => {
    try {
      const requestOptions: RequestInit = {
        method: 'POST',
        body: JSON.stringify({ event_id, id, note, contact }),
      };
      return await doFetch(`${baseURL}v1/event/update-dealer-feedback`, requestOptions);
    } catch (e) {
      console.error(`[FordD4URAPI] updateDealerFeedback`, e);
      return e;
    }
  }

  deleteDealerFeedback = async (event_id: number, id: string): Promise<D4URxFetchResult | unknown | undefined> => {
    try {
      const requestOptions: RequestInit = {
        method: 'POST',
        body: JSON.stringify({ event_id, id }),
      };
      return await doFetch(`${baseURL}v1/event/delete-dealer-feedback`, requestOptions);
    } catch (e) {
      console.error(`[FordD4URAPI] deleteDealerFeedback`, e);
      return e;
    }
  }

  addOutreachNote = async (event_id: number, note: string, created_by_email: string, created_by_name: string): Promise<D4URxFetchResult | unknown | undefined> => {
    console.log(`[FordD4URAPI] addOutreachNote`);

    try {
      const requestOptions: RequestInit = {
        method: 'POST',
        body: JSON.stringify({ 
          event_id, 
          note, 
          created_by_email,
          created_by_name 
        }),
      };

      const ret = await doFetch(`${baseURL}v1/event/add-outreach-note`, requestOptions);
      return ret;
    } catch (e) {
      // handle error
      console.error('addOutreachNote', e);
      console.error(`[FordD4URAPI] addOutreachNote`, e);
      return e;
    }
  }

  updateOutreachNote = async (event_id: number, original_timestamp: string, original_note_content: string, new_note_content: string): Promise<D4URxFetchResult | unknown | undefined> => {
    console.log(`[FordD4URAPI] updateOutreachNote`);

    try {
      const requestOptions: RequestInit = {
        method: 'POST',
        body: JSON.stringify({ 
          event_id, 
          original_timestamp,
          original_note_content,
          note: new_note_content
        }),
      };

      const ret = await doFetch(`${baseURL}v1/event/update-outreach-note`, requestOptions);
      return ret;
    } catch (e) {
      // handle error
      console.error('updateOutreachNote', e);
      console.error(`[FordD4URAPI] updateOutreachNote`, e);
      return e;
    }
  }

  deleteOutreachNote = async (event_id: number, original_timestamp: string, note_content: string): Promise<D4URxFetchResult | unknown | undefined> => {
    console.log(`[FordD4URAPI] deleteOutreachNote`);

    try {
      const requestOptions: RequestInit = {
        method: 'DELETE',
        body: JSON.stringify({ 
          event_id, 
          original_timestamp,
          note_content
        }),
      };

      const ret = await doFetch(`${baseURL}v1/event/delete-outreach-note`, requestOptions);
      return ret;
    } catch (e) {
      // handle error
      console.error('deleteOutreachNote', e);
      console.error(`[FordD4URAPI] deleteOutreachNote`, e);
      return e;
    }
  }

  addDealerNote = async (event_id: number, note: string, created_by_email: string, created_by_name: string): Promise<D4URxFetchResult | unknown | undefined> => {
    console.log(`[FordD4URAPI] addDealerNote`);

    try {
      const requestOptions: RequestInit = {
        method: 'POST',
        body: JSON.stringify({ 
          event_id, 
          note, 
          created_by_email,
          created_by_name 
        }),
      };

      const ret = await doFetch(`${baseURL}v1/event/add-dealer-note`, requestOptions);
      return ret;
    } catch (e) {
      // handle error
      console.error('addDealerNote', e);
      console.error(`[FordD4URAPI] addDealerNote`, e);
      return e;
    }
  }

  updateDealerNote = async (event_id: number, original_timestamp: string, original_note_content: string, new_note_content: string): Promise<D4URxFetchResult | unknown | undefined> => {
    console.log(`[FordD4URAPI] updateDealerNote`);

    try {
      const requestOptions: RequestInit = {
        method: 'POST',
        body: JSON.stringify({ 
          event_id, 
          original_timestamp,
          original_note_content,
          note: new_note_content
        }),
      };

      const ret = await doFetch(`${baseURL}v1/event/update-dealer-note`, requestOptions);
      return ret;
    } catch (e) {
      // handle error
      console.error('updateDealerNote', e);
      console.error(`[FordD4URAPI] updateDealerNote`, e);
      return e;
    }
  }

  deleteDealerNote = async (event_id: number, original_timestamp: string, note_content: string): Promise<D4URxFetchResult | unknown | undefined> => {
    console.log(`[FordD4URAPI] deleteDealerNote`);

    try {
      const requestOptions: RequestInit = {
        method: 'DELETE',
        body: JSON.stringify({ 
          event_id, 
          original_timestamp,
          note_content
        }),
      };

      const ret = await doFetch(`${baseURL}v1/event/delete-dealer-note`, requestOptions);
      return ret;
    } catch (e) {
      // handle error
      console.error('deleteDealerNote', e);
      console.error(`[FordD4URAPI] deleteDealerNote`, e);
      return e;
    }
  }

  // Dealer-specific note methods (for dealers page)
  addDealerNoteByDealerId = async (dealer_id: number, note: string, created_by_email: string, created_by_name: string): Promise<D4URxFetchResult | unknown | undefined> => {
    console.log(`[FordD4URAPI] addDealerNoteByDealerId`);

    try {
      const requestOptions: RequestInit = {
        method: 'POST',
        body: JSON.stringify({ 
          dealer_id, 
          note, 
          created_by_email,
          created_by_name 
        }),
      };

      const ret = await doFetch(`${baseURL}v1/event/add-dealer-note-by-dealer-id`, requestOptions);
      return ret;
    } catch (e) {
      // handle error
      console.error('addDealerNoteByDealerId', e);
      console.error(`[FordD4URAPI] addDealerNoteByDealerId`, e);
      return e;
    }
  }

  updateDealerNoteByDealerId = async (dealer_id: number, original_timestamp: string, original_note_content: string, new_note_content: string): Promise<D4URxFetchResult | unknown | undefined> => {
    console.log(`[FordD4URAPI] updateDealerNoteByDealerId`);

    try {
      const requestOptions: RequestInit = {
        method: 'POST',
        body: JSON.stringify({ 
          dealer_id, 
          original_timestamp,
          original_note_content,
          note: new_note_content
        }),
      };

      const ret = await doFetch(`${baseURL}v1/event/update-dealer-note-by-dealer-id`, requestOptions);
      return ret;
    } catch (e) {
      // handle error
      console.error('updateDealerNoteByDealerId', e);
      console.error(`[FordD4URAPI] updateDealerNoteByDealerId`, e);
      return e;
    }
  }

  deleteDealerNoteByDealerId = async (dealer_id: number, original_timestamp: string, note_content: string): Promise<D4URxFetchResult | unknown | undefined> => {
    console.log(`[FordD4URAPI] deleteDealerNoteByDealerId`);

    try {
      const requestOptions: RequestInit = {
        method: 'DELETE',
        body: JSON.stringify({ 
          dealer_id, 
          original_timestamp,
          note_content
        }),
      };

      const ret = await doFetch(`${baseURL}v1/event/delete-dealer-note-by-dealer-id`, requestOptions);
      return ret;
    } catch (e) {
      // handle error
      console.error('deleteDealerNoteByDealerId', e);
      console.error(`[FordD4URAPI] deleteDealerNoteByDealerId`, e);
      return e;
    }
  }

  getCheckQueue = async (seasonID: number): Promise<D4URxFetchResult | unknown | undefined> => {
    console.log(`[FordD4URAPI] getCheckQueue`);

    try {
      const requestOptions: RequestInit = {
        method: 'GET',
      };

      // TODO: eventually let them pick seasons
      const ret = await doFetch(`${baseURL}v1/event/check_queue?season_id=${seasonID}`, requestOptions);
      return ret;
    } catch (e) {
      // handle error
      console.error('getCheckQueue', e);
      console.error(`[FordD4URAPI] getCheckQueue`, e);
      return e;
    }
  }

  getEventRequest = async (event_request_id: string): Promise<D4URxFetchResult | unknown | undefined> => {
    console.log(`[FordD4URAPI] getEventRequest`);

    try {
      const requestOptions: RequestInit = {
        method: 'GET',
      };

      // TODO: eventually let them pick seasons
      const ret = await doFetch(`${baseURL}v1/event/request/${event_request_id}`, requestOptions);
      console.log('event request ret :', ret);
      return ret;
    } catch (e) {
      // handle error
      console.error('getEventRequest', e);
      console.error(`[FordD4URAPI] getEventRequest`, e);
      return e;
    }
  }

  getEvent = async (event_id: string): Promise<D4URxFetchResult | unknown | undefined> => {
    console.log(`[FordD4URAPI] getEvent`);

    try {
      const requestOptions: RequestInit = {
        method: 'GET',
      };

      // TODO: eventually let them pick seasons
      const ret = await doFetch(`${baseURL}v1/event/detail/${event_id}`, requestOptions);
      return ret;
    } catch (e) {
      // handle error
      console.error('getEvent', e);
      console.error(`[FordD4URAPI] getEvent`, e);
      return e;
    }
  }

  getEventToken = async (event_id: string): Promise<D4URxFetchResult | unknown | undefined> => {
    console.log(`[FordD4URAPI] getEventToken`);

    try {
      const requestOptions: RequestInit = {
        method: 'POST',
        body: JSON.stringify({ event_id }),
      };

      const ret = await doFetch(`${baseURL}v1/auth/create_login_token`, requestOptions);
      return ret;
    } catch (e) {
      // handle error
      console.error('getEventToken', e);
      console.error(`[FordD4URAPI] getEventToken`, e);
      return e;
    }
  }

  getUsers = async (): Promise<D4URxFetchResult | unknown | undefined> => {
    console.log(`[FordD4URAPI] getUsers`);

    try {
      const requestOptions: RequestInit = {
        method: 'GET',
      };

      const ret = await doFetch(`${baseURL}v1/user/users`, requestOptions);
      return ret;
    } catch (e) {
      // handle error
      console.error('getUsers', e);
      console.error(`[FordD4URAPI] getUsers`, e);
      return e;
    }
  }

  getUser = async (user_id: string): Promise<D4URxFetchResult | unknown | undefined> => {
    console.log(`[FordD4URAPI] getUser`);

    try {
      const requestOptions: RequestInit = {
        method: 'GET',
      };

      const ret = await doFetch(`${baseURL}v1/user/user/${user_id}`, requestOptions);
      return ret;
    } catch (e) {
      // handle error
      console.error('getUser', e);
      console.error(`[FordD4URAPI] getUser`, e);
      return e;
    }
  }

  createUser = async (user: UserDetails): Promise<D4URxFetchResult | unknown | undefined> => {
    console.log(`[FordD4URAPI] createUser`);

    try {
      const requestOptions: RequestInit = {
        method: 'POST',
        body: JSON.stringify({ user }),
      };

      const ret = await doFetch(`${baseURL}v1/user/user/`, requestOptions);
      return ret;
    } catch (e) {
      // handle error
      console.error('createUser', e);
      console.error(`[FordD4URAPI] createUser`, e);
      return e;
    }
  }

  updateUser = async (user: UserDetails): Promise<D4URxFetchResult | unknown | undefined> => {
    console.log(`[FordD4URAPI] updateUser`);

    try {
      const requestOptions: RequestInit = {
        method: 'POST',
        body: JSON.stringify({ user }),
      };

      const ret = await doFetch(`${baseURL}v1/user/user/${user.user_id}`, requestOptions);
      return ret;
    } catch (e) {
      // handle error
      console.error('updateUser', e);
      console.error(`[FordD4URAPI] updateUser`, e);
      return e;
    }
  }

  getDealers = async (): Promise<D4URxFetchResult | unknown | undefined> => {
    console.log(`[FordD4URAPI] getDealers`);

    try {
      const requestOptions: RequestInit = {
        method: 'GET',
      };

      const ret = await doFetch(`${baseURL}v1/event/dealers`, requestOptions);
      return ret;
    } catch (e) {
      // handle error
      console.error('getDealers', e);
      console.error(`[FordD4URAPI] getDealers`, e);
      return e;
    }
  }

  getDealer = async (dealer_id: string): Promise<D4URxFetchResult | unknown | undefined> => {
    console.log(`[FordD4URAPI] getDealer`);

    try {
      const requestOptions: RequestInit = {
        method: 'GET',
      };

      const ret = await doFetch(`${baseURL}v1/event/dealer/${dealer_id}`, requestOptions);
      return ret;
    } catch (e) {
      // handle error
      console.error('getDealer', e);
      console.error(`[FordD4URAPI] getDealer`, e);
      return e;
    }
  }

  updateDealer = async (dealer: Dealer): Promise<D4URxFetchResult | unknown | undefined> => {
    console.log(`[FordD4URAPI] updateDealer`);

    try {
      const requestOptions: RequestInit = {
        method: 'POST',
        body: JSON.stringify({ dealer }),
      };

      const ret = await doFetch(`${baseURL}v1/event/dealer/update/${dealer.dealer_id}`, requestOptions);
      return ret;
    } catch (e) {
      // handle error
      console.error('updateDealer', e);
      console.error(`[FordD4URAPI] updateDealer`, e);
      return e;
    }
  }

  inviteOffWaitlist = async (dealer_id: number, invited_off: boolean): Promise<D4URxFetchResult | unknown | undefined> => {
    console.log(`[FordD4URAPI] inviteOffWaitlist`);

    try {
      const requestOptions: RequestInit = {
        method: 'POST',
        body: JSON.stringify({ dealer_id, invited_off }),
      };

      const ret = await doFetch(`${baseURL}v1/event/invite-off-waitlist/${dealer_id}`, requestOptions);
      return ret;
    } catch (e) {
      // handle error
      console.error('inviteOffWaitlist', e);
      console.error(`[FordD4URAPI] inviteOffWaitlist`, e);
      return e;
    }
  }

  getWaitlistData = async (): Promise<D4URxFetchResult | unknown | undefined> => {
    console.log(`[FordD4URAPI] getWaitlistData`);

    try {
      const requestOptions: RequestInit = {
        method: 'GET',
      };

      const ret = await doFetch(`${baseURL}v1/event/waitlist-data`, requestOptions);
      return ret;
    } catch (e) {
      // handle error
      console.error('getWaitlistData', e);
      console.error(`[FordD4URAPI] getWaitlistData`, e);
      return e;
    }
  }

  closeWaitlist = async (): Promise<D4URxFetchResult | unknown | undefined> => {
    console.log(`[FordD4URAPI] closeWaitlist`);

    try {
      const requestOptions: RequestInit = {
        method: 'POST',
      };

      const ret = await doFetch(`${baseURL}v1/event/close-waitlist`, requestOptions);
      return ret;
    } catch (e) {
      // handle error
      console.error('closeWaitlist', e);
      console.error(`[FordD4URAPI] closeWaitlist`, e);
      return e;
    }
  }

  updateCharity = async (charity: Charity): Promise<D4URxFetchResult | unknown | undefined> => {
    console.log(`[FordD4URAPI] updateCharity`);

    try {
      const requestOptions: RequestInit = {
        method: 'POST',
        body: JSON.stringify({ charity }),
      };

      const ret = await doFetch(`${baseURL}v1/event/charity/${charity.charity_id}`, requestOptions);
      return ret;
    } catch (e) {
      // handle error
      console.error('updateCharity', e);
      console.error(`[FordD4URAPI] updateCharity`, e);
      return e;
    }
  }

  updateEvent = async (event: D4URxEvent): Promise<D4URxFetchResult | unknown | undefined> => {
    console.log(`[FordD4URAPI] updateEvent`);

    try {
      const requestOptions: RequestInit = {
        method: 'POST',
        body: JSON.stringify({ event }),
      };

      const ret = await doFetch(`${baseURL}v1/event/update/${event.event_id}`, requestOptions);
      return ret;
    } catch (e) {
      // handle error
      console.error('updateEvent', e);
      console.error(`[FordD4URAPI] updateEvent`, e);
      return e;
    }
  }

  updateEligibility = async (event_request: D4URxEvent): Promise<D4URxFetchResult | unknown | undefined> => {
    console.log(`[FordD4URAPI] updateEligibility`, JSON.parse(event_request.json));

    try {
      const requestOptions: RequestInit = {
        method: 'POST',
        body: JSON.stringify({ event_request: JSON.parse(event_request.json) }),
      };

      const ret = await doFetch(`${baseURL}v1/event/request/update/${event_request.event_request_id}`, requestOptions);
      return ret;
    } catch (e) {
      // handle error
      console.error('updateEligibility', e);
      console.error(`[FordD4URAPI] updateEligibility`, e);
      return e;
    }
  }

  setEligibleEventRequest = async (event_request_id: number, assigned_planner: number): Promise<D4URxFetchResult | unknown | undefined> => {
    console.log(`[FordD4URAPI] setEligibleEventRequest`);

    try {
      const requestOptions: RequestInit = {
        method: 'POST',
        body: JSON.stringify({ assigned_planner }),
      };

      // TODO: eventually let them pick seasons
      const ret = await doFetch(`${baseURL}v1/event/request/eligible/${event_request_id}`, requestOptions);
      return ret;
    } catch (e) {
      // handle error
      console.error('setEligibleEventRequest', e);
      console.error(`[FordD4URAPI] setEligibleEventRequest`, e);
      return e;
    }
  }

  setIneligibleEventRequest = async (event_request_id: number, declineReason?: string): Promise<D4URxFetchResult | unknown | undefined> => {
    console.log(`[FordD4URAPI] setIneligibleEventRequest`);

    try {
      const requestOptions: RequestInit = {
        method: 'POST',
        body: JSON.stringify({ declineReason }),
      };

      // TODO: eventually let them pick seasons
      const ret = await doFetch(`${baseURL}v1/event/request/ineligible/${event_request_id}`, requestOptions);
      return ret;
    } catch (e) {
      // handle error
      console.error('setIneligibleEventRequest', e);
      console.error(`[FordD4URAPI] setIneligibleEventRequest`, e);
      return e;
    }
  }

  rejectPlan = async (event_request_id: number, message: string): Promise<D4URxFetchResult | unknown | undefined> => {
    console.log(`[FordD4URAPI] rejectPlan`);

    try {
      const requestOptions: RequestInit = {
        method: 'POST',
        body: JSON.stringify({ message }),
      };

      const ret = await doFetch(`${baseURL}v1/event/event_request/${event_request_id}/reject`, requestOptions);
      return ret;
    } catch (e) {
      // handle error
      console.error('rejectPlan', e);
      console.error(`[FordD4URAPI] rejectPlan`, e);
      return e;
    }
  }

  denyPlan = async (event_request_id: number, message: string): Promise<D4URxFetchResult | unknown | undefined> => {
    console.log(`[FordD4URAPI] denyPlan`);

    try {
      const requestOptions: RequestInit = {
        method: 'POST',
        body: JSON.stringify({ message }),
      };

      // TODO: eventually let them pick seasons
      const ret = await doFetch(`${baseURL}v1/event/request/deny/${event_request_id}`, requestOptions);
      return ret;
    } catch (e) {
      // handle error
      console.error('denyPlan', e);
      console.error(`[FordD4URAPI] denyPlan`, e);
      return e;
    }
  }

  approvePlan = async (event_request_id: number): Promise<D4URxFetchResult | unknown | undefined> => {
    console.log(`[FordD4URAPI] approvePlan`);

    try {
      const requestOptions: RequestInit = {
        method: 'POST',
        body: JSON.stringify({ message: 'Event Approved' }),
      };

      // TODO: eventually let them pick seasons
      const ret = await doFetch(`${baseURL}v1/event/request/approve/${event_request_id}`, requestOptions);
      return ret;
    } catch (e) {
      // handle error
      console.error('approvePlan', e);
      console.error(`[FordD4URAPI] approvePlan`, e);
      return e;
    }
  }

  getPlanners = async (): Promise<D4URxFetchResult | unknown | undefined> => {
    console.log(`[FordD4URAPI] getPlanners`);

    try {
      const requestOptions: RequestInit = {
        method: 'GET',
      };

      // TODO: eventually let them pick seasons
      const ret = await doFetch(`${baseURL}v1/event/planners`, requestOptions);
      return ret;
    } catch (e) {
      // handle error
      console.error('getPlanners', e);
      console.error(`[FordD4URAPI] getPlanners`, e);
      return e;
    }
  }

  saveEventPlan = async (eventPlan: D4URxEvent, rawFile: any): Promise<D4URxFetchResult | unknown | undefined> => {
    console.log(`[FordD4URAPI] saveEventPlan`);

    delete eventPlan.edit_log;

    const formData = new FormData();
    // set raw file data first
    rawFile && formData.append('event_plan_file', rawFile);

    // loop properties and add to form data
    const rawObject = JSON.parse(eventPlan.json);
    for (const name in rawObject) {
      rawObject[name] && formData.append(name, rawObject[name]);
    }

    try {
      const requestOptions: RequestInit = {
        method: 'POST',
        body: formData,
      };

      const ret = await doMultipart(`${baseURL}v1/event/event_request/${eventPlan.event_request_id}`, requestOptions);
      return ret;
    } catch (e) {
      // handle error
      console.error('saveEventPlan', e);
      stores.ui.setIsLoggingIn(false);
      console.error(`[FordD4URAPI] saveEventPlan`, e);
      return e;
    }
  }

  submitFinalApproval = async (
    event_request_id: any,
    classification?: {
      organizationType: string;
      organizationSubcategory: string;
      fundingPurposeCategory: string;
      fbtPartner: string | null;
      checkPayable: string;
      memo: string | null;
    },
  ): Promise<D4URxFetchResult | unknown | undefined> => {
    console.log(`[FordD4URAPI] submitFinalApproval`);

    try {
      const requestOptions: RequestInit = {
        method: 'POST',
        body: JSON.stringify(classification || {}),
      };

      const ret = await doFetch(`${baseURL}v1/event/event_request/${event_request_id}/approve`, requestOptions);
      return ret;
    } catch (e) {
      // handle error
      console.error('submitFinalApproval', e);
      stores.ui.setIsLoggingIn(false);
      console.error(`[FordD4URAPI] submitFinalApproval`, e);
      return e;
    }
  }

  submitDonationApproval = async (event_id: any, event_summary: string, check_amount: string, valid_post_count: number, bonus_valid_count: number, memo: string = ''): Promise<D4URxFetchResult | unknown | undefined> => {
    console.log(`[FordD4URAPI] submitDonationApproval`, { event_id, event_summary, check_amount, valid_post_count, bonus_valid_count, memo });
    try {
      const requestOptions: RequestInit = {
        method: 'POST',
        body: JSON.stringify({ event_summary, check_amount, valid_post_count, bonus_valid_count, memo }),
      };

      const ret = await doFetch(`${baseURL}v1/checks/donation_approval/${event_id}`, requestOptions);
      return ret;
    } catch (e) {
      // handle error
      console.error('submitDonationApproval', e);
      stores.ui.setIsLoggingIn(false);
      console.error(`[FordD4URAPI] submitDonationApproval`, e);
      return e;
    }
  }

  submitForcedDonationApproval = async (event_id: any, event_summary: string, check_amount: string, valid_post_count: number, bonus_valid_count: number, memo: string = ''): Promise<D4URxFetchResult | unknown | undefined> => {
    console.log(`[FordD4URAPI] submitForcedDonationApproval`, { event_id, event_summary, check_amount, valid_post_count, bonus_valid_count, memo });
    try {
      const requestOptions: RequestInit = {
        method: 'POST',
        body: JSON.stringify({ event_summary, check_amount, valid_post_count, bonus_valid_count, memo }),
      };

      const ret = await doFetch(`${baseURL}v1/checks/forced_address_donation_approval/${event_id}`, requestOptions);
      return ret;
    } catch (e) {
      // handle error
      console.error('submitForcedDonationApproval', e);
      stores.ui.setIsLoggingIn(false);
      console.error(`[FordD4URAPI] submitForcedDonationApproval`, e);
      return e;
    }
  }

  submitReimbursementApproval = async (event_id: any, amount: number): Promise<D4URxFetchResult | unknown | undefined> => {
    console.log(`[FordD4URAPI] submitReimbursementApproval`);
    try {
      const requestOptions: RequestInit = {
        method: 'POST',
        body: JSON.stringify({ amount }),
      };

      const ret = await doFetch(`${baseURL}v1/event/reimbursement_approval/${event_id}`, requestOptions);
      return ret;
    } catch (e) {
      // handle error
      console.error('submitReimbursementApproval', e);
      stores.ui.setIsLoggingIn(false);
      console.error(`[FordD4URAPI] submitReimbursementApproval`, e);
      return e;
    }
  }

  submitForcedReimbursementApproval = async (event_id: any, amount: number): Promise<D4URxFetchResult | unknown | undefined> => {
    console.log(`[FordD4URAPI] submitForcedReimbursementApproval`);
    try {
      const requestOptions: RequestInit = {
        method: 'POST',
        body: JSON.stringify({ amount }),
      };

      const ret = await doFetch(`${baseURL}v1/event/forced_address_reimbursement_approval/${event_id}`, requestOptions);
      return ret;
    } catch (e) {
      // handle error
      console.error('submitForcedReimbursementApproval', e);
      stores.ui.setIsLoggingIn(false);
      console.error(`[FordD4URAPI] submitForcedReimbursementApproval`, e);
      return e;
    }
  }

  submitCheckApproval = async (check_queue_id: any): Promise<D4URxFetchResult | unknown | undefined> => {
    console.log(`[FordD4URAPI] submitCheckApproval`);
    try {
      const requestOptions: RequestInit = {
        method: 'GET',
      };

      const ret = await doFetch(`${baseURL}v1/checks/check_approval/${check_queue_id}`, requestOptions);
      return ret;
    } catch (e) {
      // handle error
      console.error('submitCheckApproval', e);
      stores.ui.setIsLoggingIn(false);
      console.error(`[FordD4URAPI] submitCheckApproval`, e);
      return e;
    }
  }

  submitCheckApprovalBulk = async (check_queue_ids: number[]): Promise<D4URxFetchResult | unknown | undefined> => {
    console.log(`[FordD4URAPI] submitCheckApprovalBulk`, { check_queue_ids });
    try {
      const requestOptions: RequestInit = {
        method: 'POST',
        body: JSON.stringify({ check_queue_ids }),
      };

      const ret = await doFetch(`${baseURL}v1/checks/check_approval_bulk`, requestOptions);
      return ret;
    } catch (e) {
      console.error('submitCheckApprovalBulk', e);
      console.error(`[FordD4URAPI] submitCheckApprovalBulk`, e);
      return e;
    }
  }

  updateCheckFields = async (check_queue_id: any, memo: string | null, check_amount: number | undefined, check_payable: string): Promise<D4URxFetchResult | unknown | undefined> => {
    console.log(`[FordD4URAPI] updateCheckFields`, { check_queue_id, memo, check_amount, check_payable });
    try {
      const requestOptions: RequestInit = {
        method: 'POST',
        body: JSON.stringify({ memo, check_amount, check_payable }),
      };
      const ret = await doFetch(`${baseURL}v1/checks/update_check/${check_queue_id}`, requestOptions);
      return ret;
    } catch (e) {
      console.error('updateCheckFields', e);
      console.error(`[FordD4URAPI] updateCheckFields`, e);
      return e;
    }
  }

  resendCheckEmail = async (check_queue_id: any): Promise<D4URxFetchResult | unknown | undefined> => {
    console.log(`[FordD4URAPI] resendCheckEmail`);
    try {
      const requestOptions: RequestInit = {
        method: 'post',
      };

      const ret = await doFetch(`${baseURL}v1/checks/resend_email/${check_queue_id}`, requestOptions);
      return ret;
    } catch (e) {
      // handle error
      console.error('resendCheckEmail', e);
      stores.ui.setIsLoggingIn(false);
      console.error(`[FordD4URAPI] resendCheckEmail`, e);
      return e;
    }
  }

  // TODO: make checkExceptionData real obj
  requestCheckException = async (queuedCheck: any): Promise<D4URxFetchResult | unknown | undefined> => {
    console.log(`[FordD4URAPI] requestCheckException`);

    try {
      const requestOptions: RequestInit = {
        method: 'POST',
        body: JSON.stringify(queuedCheck),
      };

      const ret = await doFetch(`${baseURL}v1/event/check_exception_request`, requestOptions);
      return ret;
    } catch (e) {
      // handle error
      console.error('requestCheckException', e);
      console.error(`[FordD4URAPI] requestCheckException`, e);
      return e;
    }
  }

  // TODO: make checkExceptionData real obj
  approveCheckException = async (check_queue_id: any): Promise<D4URxFetchResult | unknown | undefined> => {
    console.log(`[FordD4URAPI] approveCheckException`);

    try {
      const requestOptions: RequestInit = {
        method: 'GET',
      };

      const ret = await doFetch(`${baseURL}v1/event/check_exceptions/${check_queue_id}`, requestOptions);
      return ret;
    } catch (e) {
      // handle error
      console.error('approveCheckException', e);
      console.error(`[FordD4URAPI] approveCheckException`, e);
      return e;
    }
  }

  triggerEmail = async (emailType: string, event_id: number, recipients: string = ''): Promise<D4URxFetchResult | unknown | undefined> => {
    try {
      const requestOptions: RequestInit = {
        method: 'POST',
        body: JSON.stringify({
          email_type: emailType,
          event_id,
          recipients,
        }),
      };

      const ret = await doFetch(`${baseURL}v1/event/send-email-admin`, requestOptions);
      return ret;
    } catch (e) {
      // handle error
      console.error('triggerEmail', e);
      console.error(`[FordD4URAPI] triggerEmail`, e);
      return e;
    }
  }

  cancelEvent = async (
    event: D4URxEvent,
    customEmailBody?: string,
    cancellationReason?: string,
    cancellationNotes?: string,
  ): Promise<D4URxFetchResult | unknown | undefined> => {
    try {
      const requestOptions: RequestInit = {
        method: 'POST',
        body: JSON.stringify({
          event,
          customEmailBody,
          cancellationReason,
          cancellationNotes,
        }),
      };

      const ret = await doFetch(`${baseURL}v1/event/cancel-event-admin`, requestOptions);
      return ret;
    } catch (e) {
      // handle error
      console.error('cancelEvent', e);
      console.error(`[FordD4URAPI] cancelEvent`, e);
      return e;
    }
  }

  // D4URX-2740: moves an event to a new day (YYYY-MM-DD). The API refuses a past date or one
  // after the event's season, with a message to show.
  changeEventDate = async (event_id: number, date: string): Promise<D4URxFetchResult | unknown | undefined> => {
    try {
      const requestOptions: RequestInit = {
        method: 'POST',
        body: JSON.stringify({ date }),
      };

      const ret = await doFetch(`${baseURL}v1/event/change-date/${event_id}`, requestOptions);
      return ret;
    } catch (e) {
      // handle error
      console.error('changeEventDate', e);
      console.error(`[FordD4URAPI] changeEventDate`, e);
      return e;
    }
  }

  getSeasons = async (): Promise<D4URxFetchResult | unknown | undefined> => {
    console.log(`[FordD4URAPI] getSeasons`);

    try {
      const requestOptions: RequestInit = {
        method: 'GET',
      };

      const ret = await doFetch(`${baseURL}v1/event/season-details`, requestOptions);
      return ret;
    } catch (e) {
      // handle error
      console.error('getSeasons', e);
      console.error(`[FordD4URAPI] getSeasons`, e);
      return e;
    }
  }

  getEventsBySeason = async (season_id: number): Promise<D4URxFetchResult | unknown | undefined> => {
    console.log(`[FordD4URAPI] getEventsBySeason`);

    try {
      const requestOptions: RequestInit = {
        method: 'GET',
      };

      const ret = await doFetch(`${baseURL}v1/event/event-by-season?season_id=${season_id}`, requestOptions);
      return ret;
    } catch (e) {
      console.error('getEventsBySeason', e);
      console.error(`[FordD4URAPI] getEventsBySeason`, e);
      return e;
    }
  }

  updatePreApprovalMemo = async (event_id: any, memo: string | null, check_payable: string | null): Promise<D4URxFetchResult | unknown | undefined> => {
    console.log(`[FordD4URAPI] updatePreApprovalMemo`, { event_id, memo, check_payable });
    try {
      const requestOptions: RequestInit = {
        method: 'POST',
        body: JSON.stringify({ event_id, memo, check_payable }),
      };
      const ret = await doFetch(`${baseURL}v1/event/update-pre-approval-memo`, requestOptions);
      return ret;
    } catch (e) {
      console.error('updatePreApprovalMemo', e);
      console.error(`[FordD4URAPI] updatePreApprovalMemo`, e);
      return e;
    }
  }

  getDealerSurveys = async (): Promise<D4URxFetchResult | unknown | undefined> => {
    console.log(`[FordD4URAPI] getDealerSurveys`);

    try {
      const requestOptions: RequestInit = {
        method: 'GET',
      };

      const ret = await doFetch(`${baseURL}v1/event/post-event-dealer-surveys/all`, requestOptions);
      return ret;
    } catch (e) {
      // handle error
      console.error('getDealerSurveys', e);
      console.error(`[FordD4URAPI] getDealerSurveys`, e);
      return e;
    }
  }

  // Message tester (staging only; the API returns 404 in production)
  getMessageTestTypes = async (): Promise<D4URxFetchResult | unknown | undefined> => {
    try {
      return await doFetch(`${baseURL}v1/message_test/messages`, { method: 'GET' });
    } catch (e) {
      console.error(`[FordD4URAPI] getMessageTestTypes`, e);
      return e;
    }
  }

  sendMessageTest = async (body: { event_id: number; email: string; phone: string; language: string; types: string[] }): Promise<D4URxFetchResult | unknown | undefined> => {
    try {
      return await doFetch(`${baseURL}v1/message_test/send`, { method: 'POST', body: JSON.stringify(body) });
    } catch (e) {
      console.error(`[FordD4URAPI] sendMessageTest`, e);
      return e;
    }
  }
}

export default new D4URxService();
